import pageTitle from 'ember-page-title/helpers/page-title';
import filterSort from 'bcl/helpers/filter-sort';
import { LinkTo } from '@ember/routing';
import gt from 'ember-truth-helpers/helpers/gt';
import { on } from '@ember/modifier';
import not from 'ember-truth-helpers/helpers/not';
import isEmpty from 'ember-truth-helpers/helpers/is-empty';
import sort from 'bcl/helpers/sort';
import displayDate from 'bcl/helpers/display-date';
import EventsList from 'bcl/components/events-list';
import Section from 'bcl/components/section';
import Diagramm from 'bcl/components/diagramm';
import Reports from 'bcl/components/reports';
import OrderModel from 'bcl/models/order';
import { fn } from '@ember/helper';
import Component from '@glimmer/component';
import { service } from '@ember/service';
import { array } from '@ember/helper';
import type StocktakingService from 'bcl/services/stocktaking';
import type ModalService from 'bcl/services/modal';
import type SessionService from 'bcl/services/session';
import { action } from '@ember/object';
import type RouterService from '@ember/routing/router-service';

function filterByStatus(orders: OrderModel[], status: string): OrderModel[] {
  return orders.filter((order) => order.status === status);
}

export default class AuthIndexRoute extends Component {
  @service declare stocktaking: StocktakingService;
  @service declare session: SessionService;
  @service declare router: RouterService;
  @service declare modal: ModalService;
  @action
  createOrderSpecial() {
    this.session.orderKind = 'special';
    // id wird in route/orders/new herausgesucht

    this.router.transitionTo('auth.orders.new');
  }

  <template>
    {{pageTitle "Übersicht"}}
    <header class="bg-white shadow-sm">
      <div class="mx-auto max-w-7xl px-4 py-4 lg:px-8">
        <h1 class="text-lg font-semibold leading-6 text-gray-900">Übersicht</h1>

      </div>
    </header>
    <main>
      <div class="mt-4 mx-auto max-w-7xl">
        <div class="bg-white shadow-sm rounded-md py-6 px-4 lg:px-8">

          <h2 class="text-xl font-bold mb-1">Schnellaktionen</h2>
          <h3 class="text-lg font-bold mb-2">Inventur</h3>
          {{#each
            (filterSort @model.locations "active" "name")
            as |location idx|
          }}
            <button
              class="{{if (gt idx 0) 'ml-4'}}
                rounded-md bg-indigo-600 px-3.5 py-2.5 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
              type="button"
              {{on "click" (fn this.stocktaking.startWith location.id)}}
            >Beim {{location.name}} starten</button>
          {{/each}}
          {{#each
            (filterSort
              this.stocktaking.all "status" "created_at" eq=(array "created")
            )
            as |stocktaking|
          }}
            <button
              class="ml-4 rounded-md bg-indigo-600 px-3.5 py-2.5 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
              type="button"
              {{on "click" (fn this.stocktaking.resume stocktaking.id)}}
            >Inventur vom
              {{displayDate stocktaking.created_at}}
              fortsetzen</button>
          {{/each}}
          <h3 class="text-lg font-bold mt-8 mb-2">Bestellungen</h3>
          <button
            {{on "click" this.modal.toggleNewOrder}}
            type="button"
            class="rounded-md bg-green-500 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-green-400 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-green-500"
          >Bestellung anlegen</button>
          <button
            {{on "click" this.createOrderSpecial}}
            type="button"
            class="rounded-md bg-green-500 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-green-400 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-green-500"
          >Entnahme oder Einlage</button>

          {{#let (filterByStatus @model.orders "ordered") as |model|}}
            {{#if (not (isEmpty model))}}
              {{#each (sort model "-delivery_date") as |order|}}
                <div class="block mt-4">
                  <LinkTo
                    @route="auth.orders.accept"
                    @model={{order.id}}
                    class="mr-4 rounded-md bg-indigo-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
                  >
                    annehmen
                    <span class="sr-only">, ID
                      {{order.id}}</span></LinkTo>
                  Bestellung von
                  {{order.supplier.name}}
                  zum
                  {{displayDate order.delivery_date}}

                </div>
              {{/each}}
            {{/if}}

          {{/let}}
        </div>
        <Section @heading="Statistiken">
          <Diagramm />
        </Section>
        <Section @heading="Berichte">
          <Reports />
        </Section>
        <Section @heading="Ereignisse">
          <EventsList />
        </Section>
      </div>
    </main>
  </template>
}
